import { useEffect, useState } from 'react'
import { NoteCode } from '@user/components/Notes/typings'
import { getNoteCodes } from '@user/store/notes/api'
import { useAppDispatch } from '@user/store/hooks'

export function useNoteCodes() {
  const [noteCodes, setNoteCodes] = useState<NoteCode[]>([])

  const dispatch = useAppDispatch()

  useEffect(() => {
    const getAllNoteCodes = async () => {
      try {
        const result = await dispatch(getNoteCodes())
        if (getNoteCodes.fulfilled.match(result)) {
          const { payload } = result
          setNoteCodes(payload?.items || [])
        }
      } catch (error) {
        setNoteCodes([])
      }
    }

    getAllNoteCodes()
  }, [dispatch])

  return {
    noteCodes,
  }
}
